module.exports = __webpack_public_path__ + "static/media/storefront_placeholder.b439a0a9.png";